<template>
    <div class="fixed border border-gray-300 rounded-sm z-30 w-fit text-left shadow-lg" :style="popoverPosition">
        <div class="bg-gray-100 px-2 py-1 w-full block rounded-t-sm border-b border-gray-300">
            <slot name="title"></slot>
        </div>
        <div class="w-full p-2 bg-white whitespace-pre-wrap pretty rounded-b-sm">
            <slot name="body"></slot>
        </div>
    </div>
</template>
<script setup>
import { defineProps, computed } from "vue"; 

const props = defineProps({
    xPosition: Number,
    yPosition: Number,
})

const popoverPosition = computed(function () {
    return `left: ${props.xPosition + 5}px; top: ${props.yPosition}px;`
})


</script>